import React from "react";
import type { NextPage } from "next";
import { getLandingPageProps, getPageMetaImage, type LandingPageProps } from "utils";
import { Page } from "components/page";
import { StackedLogos } from "components/logos";
import { CustomerWithStatsSlug } from "components/content";
import { HomeTemplate, HomeHero } from "components/home";

const Home: NextPage<LandingPageProps> = ({
  page,
  destinations,
  announcementBanner,
  defaultLogos,
  defaultMobileLogos,
  caseStudies,
}) => {
  return (
    <Page
      title={page.metaTitle}
      description={page.metaDescription}
      image={getPageMetaImage({ src: page.metaImageUrl, alt: page.metaTitle })}
      announcementBanner={announcementBanner}
      bgColor="new.blue.50"
      footerOptions={{ variant: "blue" }}
    >
      <HomeHero title={page.title} description={page.description} />
      <StackedLogos
        customers={defaultLogos}
        mobileCustomers={defaultMobileLogos}
        my={0}
        pt={{ base: "bigger", md: "biggest", lg: "huge" }}
      />
      <HomeTemplate destinations={destinations} caseStudies={caseStudies} />
    </Page>
  );
};

export default Home;

export const getStaticProps = getLandingPageProps("/", {
  loadDefaultLogos: true,
  loadDefaultMobileLogos: true,
  loadDestinations: "all",
  loadCaseStudies: [
    CustomerWithStatsSlug.PETSMART,
    CustomerWithStatsSlug.WMG,
    CustomerWithStatsSlug.WEIGHT_WATCHERS,
    CustomerWithStatsSlug.WHOOP,
    "chime",
    "fundrise",
  ],
});
